/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

/** Common Components */
import EmailTemplateForm from "./config/EmailTemplate.data";
import Buttons from "../../../components/ui/button/Buttons";
import CardSection from "../../../components/ui/card/CardSection";
import FormCreator from "../../../components/finalForms/FormCreator";
import PropTypes from "prop-types";

/** RTK Query */
import {
  useAddEmailTemplateMutation,
  useLazyGetEmailTemplateByIdQuery,
  useUpdateEmailTemplateMutation,
} from "../../../app/services/emailTemplateAPI";

/** Common Services & Data Files */
import ToastService from "../../../services/toastService/ToastService";

/** Utilities */
import { decryptUrlData } from "../../../services/CryptoService";



const AddEmailTemplate = (props) => {
  const navigate = useNavigate();
  const addEmailRef = useRef();

  const { id } = useParams();
  const templateId = id ? decryptUrlData(id) : 0;
  const [emailForm, setEmailForm] = useState(EmailTemplateForm);
  const [shouldRerenderFormCreator, setShouldRerenderFormCreator] = useState(false);

  const [addEmail, {
    isLoading: isEmailAdding,
    isSuccess: isEmailAdded,
    data: addemailTemplateData,
  },] = useAddEmailTemplateMutation();

  const [getEmailById, {
    isLoading: isGetByIdLoading,
    isFetching: isGetByIdFetching,
    isSuccess: isGetByIdSuccess,
    data: isGetByIdData,
  },] = useLazyGetEmailTemplateByIdQuery();

  const [updateEmail, {
    isLoading: isEmailUpdating,
    isSuccess: isEmailUpdateSuccess,
    data: isEmailUpdateData,
  },] = useUpdateEmailTemplateMutation();

  const resetForm = () => {
    const formData = { ...emailForm };
    formData.initialState = { ...emailForm.initialState };
    setEmailForm(formData);
  };

  useEffect(() => {
    resetForm();
    if (templateId) {
      getEmailById(templateId);
    }
  }, [templateId, getEmailById]);

  useEffect(() => {
    if (isGetByIdSuccess && !isGetByIdFetching && isGetByIdData)
      if (isGetByIdData) {
        let emailData = { ...emailForm };

        emailData.initialState = {
          ...emailForm.initialState,
          templateName: isGetByIdData.templateName,
          subject: isGetByIdData.subject,
          body: isGetByIdData.body,
          isActive: isGetByIdData.isActive,
        };
        setEmailForm(emailData);
        setShouldRerenderFormCreator((prevState) => !prevState);
      }
  }, [isGetByIdData, isGetByIdFetching, isGetByIdSuccess]);

  useEffect(() => {
    if (isEmailUpdateSuccess && isEmailUpdateData) {
      if (isEmailUpdateData.errorMessage.includes("exists")) {
        ToastService.warning(isEmailUpdateData.errorMessage);
        return;
      } else {
        ToastService.success(isEmailUpdateData.errorMessage);
        backToList();
      }
    }
  }, [isEmailUpdateSuccess, isEmailUpdateData]);

  useEffect(() => {
    if (isEmailAdded && addemailTemplateData) {
      if (addemailTemplateData.errorMessage.includes("exists")) {
        ToastService.warning(addemailTemplateData.errorMessage);
        return;
      } else {
        ToastService.success(addemailTemplateData.errorMessage);
        backToList();
      }
    }
  }, [isEmailAdded, addemailTemplateData]);

  const handleSubmit = () => {
    let EmailData = addEmailRef.current.getFormData();

    const requestData = {
      ...EmailData,
    };

    if (!templateId && EmailData) {

      addEmail(requestData);
    } else if (templateId && EmailData) {

      const requestUpdateData = {

        templateId: templateId,
        templateName: EmailData.templateName,
        subject: EmailData.subject,
        body: EmailData.body,
        isActive: EmailData.isActive,
      };
      
      updateEmail(requestUpdateData);
    }
  };

  const backToList = () => {
    navigate("/admin/emailTemplates");
  };

  return (
    <div className="addeditemail-template center-top-space">
      <CardSection
        isContentLoading={isEmailAdding || isEmailUpdating || isGetByIdLoading}
        cardTitle={"Email Information"}
      >
        <FormCreator
          config={emailForm}
          ref={addEmailRef}
          key={shouldRerenderFormCreator}
          {...emailForm}
        />
        <div className="d-flex justify-content-end">
          <Buttons
            buttonTypeClassName="dark-btn"
            onClick={backToList}
            buttonText="Cancel"
          />
          <Buttons
            buttonTypeClassName="theme-btn ml-4 "
            buttonText={`${templateId ? "Update" : "Add"}`}
            onClick={handleSubmit}
            isLoading={isEmailAdding || isEmailUpdating}
          />
        </div>
      </CardSection>
    </div>
  );
};

AddEmailTemplate.propTypes = {
  initData: PropTypes.shape({
    templateName: PropTypes.string,
    subject: PropTypes.string,
    body: PropTypes.string,
    isActive: PropTypes.bool,
  }),
};

export default AddEmailTemplate;
